import { Machinetype } from '../machinetype/machinetype';
import { Module } from '../module/module';
import {Client} from '../client/client';
import {Ticket} from '../ticket/ticket';
import {State} from '../state/state';
import {Location} from '../location/location';

export class Machine
{
    id: number;
    shortname: string;
    serialnumber: string;
    modelnumber: string;
    machinetype: Machinetype;
    modules: Module[];
    client: Client;
    tickets: Ticket[]; 
    state: State;
    location : Location;
    imageurl : string; 
    counter: string;
    dispatched : boolean;
}

export class MachineCreate 
{
    shortname: string;
    serialnumber: string;
    modelnumber: string;
    machinetype: number;
    modules: number[];
    client: number;
    state: number;
    location : number;
    counter: string;
    imageurl : string;
    dispatched : boolean;
}